import React, { useEffect } from "react";
import { draw } from "./draw";

export const OaRVaRD3Chart = ({
  data,
  width,
  height,
  config,
  lRef,
  palette,
  selection,
}) => {
  height = height - 4;

  useEffect(() => {
    draw(lRef.current, data, config, palette, selection);
  }, [data, width, height, config, lRef, palette, selection]);

  return <svg ref={lRef} width={width} height={height}></svg>;
};
